function splitSizeValues(value) {
  return String(value || "")
    .split(/[,;]+/)
    .map((item) => item.trim())
    .filter(Boolean);
}

export function collectCertificateSizes(certificate = {}) {
  const sizes = [];
  const push = (value) => {
    splitSizeValues(value).forEach((size) => {
      if (!sizes.includes(size)) sizes.push(size);
    });
  };

  if (Array.isArray(certificate.sizes)) {
    certificate.sizes.forEach(push);
  }
  if (Array.isArray(certificate.size)) {
    certificate.size.forEach(push);
  } else {
    push(certificate.size);
  }

  return sizes;
}

export function formatCertificateSizes(certificate) {
  return collectCertificateSizes(certificate).join(", ");
}

export function constructionTireSize(size) {
  const raw = String(size || "").replace(/\s+/g, " ").trim();
  const match = raw.match(/^(.*\d{2})(?:\s+(\d{2,3}\s*[A-Z]))$/i);
  return match ? match[1].trim() : raw;
}

export function normalizeTireSize(size) {
  return constructionTireSize(size)
    .replace(/\s+/g, "")
    .replace(/-/g, "/")
    .toUpperCase();
}

export function certificateMatchesSize(certificate, productSize) {
  const needle = normalizeTireSize(productSize);
  if (!needle) return false;

  const sizes = collectCertificateSizes(certificate);
  if (sizes.some((size) => normalizeTireSize(size) === needle)) {
    return true;
  }

  const sizeParts = String(productSize).match(/(\d{2,3})[/\-](\d{2,3}).*?(\d{2})/);
  if (!sizeParts) return false;
  const [, width, aspect, diameter] = sizeParts;

  return sizes.some((size) => {
    const parts = String(size).match(/(\d{2,3})[/\-](\d{2,3}).*?(\d{2})/);
    return (
      parts &&
      parts[1] === width &&
      parts[2] === aspect &&
      parts[3] === diameter
    );
  });
}
